
export default function ScaleAdminStep({ children }) {
  return <> {children}</>;
}